module.exports = __webpack_public_path__ + "static/img/9.71f3f7f7.png";